export function PaletteSearch({
	value,
	onChange,
}: {
	value: string;
	onChange: (v: string) => void;
}) {
	return (
		<div className="p-3">
			<input
				type="text"
				placeholder="Search activities..."
				aria-label="Search activities"
				value={value}
				onChange={(e) => onChange(e.target.value)}
				className="w-full rounded-xl border border-border bg-surface px-4 py-2 text-sm text-text-primary placeholder:text-text-muted focus:border-accent focus:outline-none focus:ring-1 focus:ring-accent"
			/>
		</div>
	);
}
